import ReportEventModal from './ReportEventModal';

export default ReportEventModal;
